import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export const SAVED_SCREENS_QUERY_KEY = ["saved-screens"] as const;

type SavedScreenSortKey = components["schemas"]["SavedScreenSortKey"];
type SortOrder = components["schemas"]["SortOrder"];

export type ListSavedScreensQuery = {
  include_deleted?: boolean;
  sort_key?: SavedScreenSortKey;
  sort_order?: SortOrder;
  limit?: number;
  offset?: number;
};

export function useSavedScreens(params: ListSavedScreensQuery = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...SAVED_SCREENS_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/screens", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list saved screens");
      }
      return data;
    },
  });
}
